import type { LucideIcon } from 'lucide-react';

interface GenericScreenProps extends React.HTMLAttributes<HTMLDivElement> {
  Icon: LucideIcon;
  title: string;
  description: string;
  leftActionElement?: React.ReactNode;
  rightActionElement?: React.ReactNode;
}

export const GenericIconScreen = ({ Icon, title, description, leftActionElement, rightActionElement, ...rest }: GenericScreenProps) => {
  return (
    <div
      className='rounded-surface bg-fill-background-neutral tablet:flex-initial tablet:py-6 tablet:min-h-[684px] flex h-full min-h-[calc(100vh-76px)] w-full max-w-[462px] flex-1 flex-col items-center justify-center'
      {...rest}
    >
      <div className='tablet:p-12 flex w-full max-w-[462px] flex-1 flex-col items-center gap-6 px-5 pt-6'>
        <div className='tablet:px-8 flex flex-1 flex-col items-center justify-center gap-4 px-6 py-4'>
          <div className='bg-fill-background-light mb-2 flex size-[120px] items-center justify-center rounded-full'>
            <Icon className='text-text-default-secondary size-[72px]' strokeWidth={1.5} aria-hidden focusable='false' data-testid='icon' />
          </div>
          <h1 className='text-heading-m-medium text-center'>{title}</h1>
          <p className='text-body-m-regular text-text-default-secondary text-center'>{description}</p>
        </div>
        {(!!leftActionElement || !!rightActionElement) && (
          <div className='max-tablet:sticky max-tablet:bottom-0 max-tablet:mt-auto max-tablet:bg-fill-background-neutral max-tablet:py-4 flex w-full gap-3 *:w-full'>
            {leftActionElement}
            {rightActionElement}
          </div>
        )}
      </div>
    </div>
  );
};
